/* import React from 'react'
import { Col, Row } from 'react-bootstrap'

function SectionOne() {
  return (
    <div className='sectionone-main'>
        <Row>
            <Col md={6} sm={6} xs={6}>
            <p>
            Read Your 
            Favorite Novels
            </p>
            </Col>

        </Row>

    </div>
  )
}

export default SectionOne */



import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { Image } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Aboutus from './Aboutus';


// import './LandingPage.css'; // Optional external CSS for extra styling

const SectionOne = () => {
    return (
        <>
        <a href="kahaaniplus.apk" download={true}>
            <Image src="/images/image1.png"
                style={{ width: "100%" }}
            />
        </a>
            <Image src="/images/image2.png"
                style={{ width: "100%" }}
            />
            <Image src="/images/image3.png"
                style={{ width: "100%" }}
            />
            <Image src="/images/image4.png"
                style={{ width: "100%" }}
            />
            <Image src="/images/subscription_plans.png"
                style={{ width: "100%" }}
            />
            <div className='footer'>
                <Row>
                    <Col md={12} sm={12} xs={12} className='footer-logo' style={{}}>
                        <Image src="/logo/Kahaani_plus_Logo.png" />
                    </Col>

                </Row>
                {/* links */}
                <Row>
                    <Col sm={4} xs={6} md={4}>
                        <Link className='footer-link' to="about">About us</Link>
                    </Col>
                    <Col sm={4} xs={6} md={4}>
                        <Link className='footer-link' to="privacy-policy">Privacy Policy</Link>
                    </Col>
                    <Col sm={4} xs={6} md={4}>
                    <Link className='footer-link' to="grievance-policy">Grievance Policy</Link>
                    </Col>
                    <Col sm={4} xs={6} md={4}>
                        <Link className='footer-link' to="contact-us">Contact us</Link>
                    </Col>
                    <Col sm={4} xs={6} md={4}>
                        <Link className='footer-link' to="terms-conditions">Terms & Conditions</Link>
                    </Col>
                    <Col sm={4} xs={6} md={4}>
                        <Link className='footer-link' to="refund-policy">Refund Policy</Link>
                    </Col>
                </Row>
            </div>

        </>

    );
};

export default SectionOne;
